import { jsonFetch } from '../client/api/api';


//For the principal listing "Experiences"
document.addEventListener('DOMContentLoaded', function() {

    let categoryTabs = document.querySelectorAll('.games-list .categories-tabs > .category-tab')
    let tagTabs = document.querySelectorAll('.games-list .tags-list > .tag-checkbox')
    let ageTabs = document.querySelectorAll('.games-list .ages-list > .age-checkbox')
    let gameList = document.getElementById('games-list')
    let mobileCategorySelect = document.querySelector('.mobile-category-select')

    let category = 'all-games' // Valeur par défaut

    categoryTabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
            categoryTabs.forEach(function(tab) {
                tab.classList.remove('active')
            });
            this.classList.add('active');
            category = this.dataset.category;

            if (mobileCategorySelect) {
                mobileCategorySelect.value = category
            }
            updateGames()
        });
    });

    tagTabs.forEach(function(tab) {
        tab.addEventListener('click', updateGames)
    })

    ageTabs.forEach(function(age) {
        age.addEventListener('click', updateGames);
    })

    if (mobileCategorySelect) {
        mobileCategorySelect.addEventListener('change', function() {
            categoryTabs.forEach(function(tab) {
                tab.classList.remove('active')
                if (tab.dataset.category === mobileCategorySelect.value) {
                    tab.classList.add('active')
                }
            });
            category = mobileCategorySelect.value
            updateGames()

            const gamesListElement = document.getElementById('gamesList');
            const gamesListElement2 = document.getElementById('games-list');
            if (gamesListElement) {
                gamesListElement.scrollIntoView({ behavior: 'smooth' });
            }
            if (gamesListElement2) {
                gamesListElement2.scrollIntoView({ behavior: 'smooth' });
            }
        })
    }

    // Functions to update the games list
    async function updateGames() {

        // Add loading
        let gameCards = document.querySelectorAll('.game-card');
        let loading = document.getElementById('loading');
        gameCards?.forEach(card => {
            card.classList.add('loading');
        });
        loading?.classList.remove('hidden');
        loading?.classList.add('show');
        // End add loading

        let cat = 'all-games'; 

        categoryTabs.forEach(function(tab) {
            if (tab.classList.contains('active')) {
                cat = tab.dataset.category
            }
        })

        let tags = []
        tagTabs.forEach(function(tab) {
            if (tab.checked) {
                tags.push(tab.dataset.tag)
            }
        })

        let ages = []
        ageTabs.forEach(function(tab) {
            if (tab.checked) {
                ages.push(tab.dataset.age)
            }
        })

        let params = new FormData()
        params.append('action', 'filter_list_games')
        params.append('category', cat)
        params.append('tags', tags)
        params.append('ages', ages)
        
        const response = await jsonFetch(kreenoot_child.ajax_url, {
            method: "POST",
            body: params,
        });

        // Ajoute ce code pour simuler un délai de la requête AJAX (DEBUG)
        // await new Promise(resolve => setTimeout(resolve, 2000));
    
        // Remove loading
        gameCards.forEach(card => {
            card.classList.remove('loading');
        });
        loading?.classList.remove('show');
        loading?.classList.add('hidden');
        // End remove loading

        if (response.success) {
            gameList.innerHTML = response.data
        } else {
            console.log(response.data)
        }
    }
});